import { Button, List, Tooltip } from "antd";
import { DownloadIcon, SearchIcon } from "../../../../../atoms/CustomIcons";
import Input from "antd/es/input/Input";

export default function Equipment() {
  const data = ["Shovels", "Hand Trowel", "Garden Fork"];

  return (
    <div className="equipmentList">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <h3> Equipment </h3>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <div className="filterSearch">
            <Input prefix={<SearchIcon />} placeholder="Search" allowClear />
          </div>
          <div className="filterDownload">
            <Tooltip title="Export the list of equipment">
              <Button
                icon={<DownloadIcon />}
                style={{ height: "36px", width: "36px" }}
              />
            </Tooltip>
          </div>
        </div>
      </div>
      <List
        header={<div>Name</div>}
        bordered
        dataSource={data}
        renderItem={(item) => <List.Item>{item}</List.Item>}
      />
    </div>
  );
}
